import React from 'react';
import { graphql, usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import { Flex } from '@atlaskit/primitives/compiled';
import type { JQLBuilderProps } from '@atlassian/jira-jql-builder/src/common/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import FilterRefinement from '@atlassian/jira-filter-refinement/src/ui/FilterRefinement.tsx';
import type { JQLBuilderWithAIFilterRefinementQuery } from './__generated__/JQLBuilderWithAIFilterRefinementQuery.graphql';
import messages from './messages.tsx';

type Props = Pick<
	JQLBuilderProps,
	'query' | 'onSearch' | 'beforeControls' | 'projectContext' | 'onReset'
> & {
	filterRefinementQueryReference: PreloadedQuery<JQLBuilderWithAIFilterRefinementQuery>;
};

export const JQLBuilderWithAIFilterRefinement = ({
	query,
	onSearch,
	beforeControls,
	filterRefinementQueryReference,
	projectContext,
	onReset,
}: Props): React.JSX.Element => {
	const filterRefinementData = usePreloadedQuery<JQLBuilderWithAIFilterRefinementQuery>(
		graphql`
			query JQLBuilderWithAIFilterRefinementQuery(
				$cloudId: ID!
				$isFilterRefinementEnabled: Boolean!
			) {
				jira {
					...FilterRefinement @arguments(cloudId: $cloudId) @include(if: $isFilterRefinementEnabled)
				}
			}
		`,
		filterRefinementQueryReference,
	);

	const { formatMessage } = useIntl();

	return (
		<Flex gap="space.075" justifyContent="start" alignItems="center">
			{beforeControls}
			<FilterRefinement
				defaultJql={query}
				fragmentRef={filterRefinementData.jira}
				onSearch={onSearch}
				searchFieldPlaceholder={formatMessage(messages.searchWork)}
				isModeSwitcherEnabled
				isResponsive={false}
				projectContext={projectContext}
				onReset={onReset}
			/>
		</Flex>
	);
};
